"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTextStyles = exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _reactDom = require("react-dom");
var _context = require("../context");
var _utils = require("../autosuggest/utils");
var _constants = require("../constants");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var getTextStyles = exports.getTextStyles = function getTextStyles(selection) {
  var textStyles = {};
  if (!selection || !selection.getNode()) {
    return textStyles;
  }
  var computedStyles = getComputedStyle(selection.getNode());
  _constants.TEXT_FORMATS.forEach(function (format) {
    return textStyles[format] = computedStyles[format];
  });
  return textStyles;
};
var _default = exports["default"] = function _default(_ref) {
  var _ref$suggestions = _ref.suggestions,
    suggestions = _ref$suggestions === void 0 ? [] : _ref$suggestions;
  var editor = (0, _context.useEditor)();
  var _useState = (0, _react.useState)(null),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    selection = _useState2[0],
    setSelection = _useState2[1];
  (0, _react.useEffect)(function () {
    var handleSelectionChange = function handleSelectionChange(event) {
      var editorSelection = editor.selection;
      var _editorSelection$getS = editorSelection.getSel(),
        anchorNode = _editorSelection$getS.anchorNode,
        focusNode = _editorSelection$getS.focusNode,
        focusOffset = _editorSelection$getS.focusOffset;
      var newSelection = {
        selection: editorSelection,
        anchorNode: anchorNode,
        focusNode: focusNode,
        focusOffset: focusOffset,
        currentNode: editorSelection.getNode(),
        startElement: editorSelection.getStart()
      };
      setSelection(newSelection);
    };
    editor.on('SelectionChange input', handleSelectionChange);
    return function () {
      editor.off('SelectionChange input', handleSelectionChange);
    };
  }, [editor]);
  var suggestion = (0, _react.useMemo)(function () {
    if (!selection) return null;
    var value = (0, _utils.getSuggestion)(editor, suggestions, selection);
    var position = (0, _utils.getSuggestionPosition)(editor, selection);
    var textStyles = getTextStyles(selection.selection);
    return {
      value: value,
      position: position,
      textStyles: textStyles
    };
  }, [selection === null || selection === void 0 ? void 0 : selection.focusNode, selection === null || selection === void 0 ? void 0 : selection.focusOffset]);
  if (!suggestion) return null;
  if (!suggestion.value) return null;
  return /*#__PURE__*/(0, _reactDom.createPortal)( /*#__PURE__*/_react["default"].createElement("div", {
    id: "autosuggest-tag",
    className: "absolute !text-gray-light pointer-events-none",
    contentEditable: false,
    style: _objectSpread(_objectSpread({}, suggestion.position), suggestion.textStyles)
  }, suggestion.value), editor.getContainer());
};
//# sourceMappingURL=SuggestionTagContainer.js.map